export default "__VITE_ASSET__5ffef050__"